export default __webpack_public_path__ + "static/B0167-3c4ce765a23f38b57c14688e0e08318a.png";